import ReCaptchaProvider from './ReCaptchaProvider';
import AltchaProvider from './AltchaProvider';
import HCaptchaProvider from './HCaptchaProvider';

const CAPTCHA_TYPES = {
    RECAPTCHA: 'recaptcha',
    ALTCHA: 'altcha',
    HCAPTCHA: 'hcaptcha',
};

export default class CaptchaFactory {
    static create(type, element, verifyCallback, config = {}) {
        switch (type) {
            case CAPTCHA_TYPES.RECAPTCHA:
                return new ReCaptchaProvider(element, verifyCallback, config);
            
            case CAPTCHA_TYPES.ALTCHA:
                return new AltchaProvider(element, verifyCallback, config);
            
            case CAPTCHA_TYPES.HCAPTCHA:
                return new HCaptchaProvider(element, verifyCallback, config);
            
            default:
                throw new Error(`Unsupported captcha type: ${type}`);
        }
    }

    static get types() {
        return CAPTCHA_TYPES;
    }
}